<template>
  <div id="app">
    <div class="home">
      <!-- 页头 -->
      <div class="header">
        <heads></heads>
      </div>
      <!-- 页面主体 -->
      <div class="body">
        <!-- 侧边导航栏 -->
		<aside v-show="showAside">
          <!-- <yhaside @getAcived="getAcived"></yhaside> -->
		  <common-nav></common-nav>     
        </aside>
		
        <!-- 主体内容 -->
        <div class="body-con">
         <!-- <h2 class="body-con-con-title" v-if="showAside">{{title}}</h2> -->
          <div class="body-con-con">
            <router-view style="height: 100%; width: 100%;overflow: auto;"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // @ is an alias to /src
  // import Swiper from "swiper";
  // import "swiper/dist/css/swiper.min.css";
  // import domtoimage from "dom-to-image";
  // import html2canvas from "html2canvas";
  // import urlConfig from "./url";
  import limitMoreClick from "../utils/limitMoreClick";
  import heads from "./components/m_header";
  import yhaside from "./components/yh_aside";
  import CommonNav from "./components/common-nav";
  export default {
    name: "home",
    components: {heads, yhaside,CommonNav},
    data() {
      return {title:'',
        showAside:true,
      };
    },
    mounted() {
      if(!this.title){
        this.title = localStorage.getItem('breadTitle');
      }
      // 智能咨询、在线客服 隐藏右下角导航栏
      if(/(customerService)/.test(location.href)){
        this.showAside = false;
      }else{
        this.showAside = true;
      }
    },
    methods: {
      // 获取当前激活的选项
      getAcived(dat) {
        console.log('获取当前激活的选项::', dat);
        this.title = dat.label;
        localStorage.setItem('breadTitle',dat.label);
      },
      // 随机数
      randomNum(minNum, maxNum) {
        switch (arguments.length) {
          case 1:
            return parseInt(Math.random() * minNum + 1, 10);
            break;
          case 2:
            return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
            break;
          default:
            return 0;
            break;
        }
      }
    }
  };
</script>
<style>
  html,
  body,
  #app {
    height: 100%;
  }

  body {
    font-size: 14px !important;
  }
</style>

<style lang="scss">
  .home {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
	overflow: hidden;
    cursor: default;
    .header {
      box-sizing: border-box;
      height:70px;
	 //background: linear-gradient(to right, #536976, #292e49);
	  background: linear-gradient(to left,#9853af,#623AA2);
	  border-bottom:1px solid rgba(255,255,255,0.09);
    }

    .body {
      position: relative;
      height: calc(100% - 70px);
      box-sizing: border-box;
      padding: 0 0 0 5rem;
      background-color: #f3f3f3;
      // 侧边栏
      aside {
        width: 180px;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
		//background:  linear-gradient(to bottom, #536976, #292e49);
		background: #25202D;
      }
      // 主体内容
      .body-con {
		width: calc(100% - 180px);
        height: 100%;
		position: absolute;
		left: 180px;
		overflow: hidden;
		background: #F2F2F2;
        .body-con-con {
        //  height: calc(~"100% - 50px");
		  height: 100%;
         // background-color: #fff;
          overflow-y: auto;
		  &::-webkit-scrollbar { width: 0 !important }
        }
      }
    }
  }
  .el-range-separator{
    width: 10% !important;
  }
 //  @include tweak(edit-btn){
 //  	background: linear-gradient(to bottom right, #62fb62, #21a544);
	// color: #fff;
	// border:none
 //  }
 //  @include tweak(warning-btn){
 //  	background: linear-gradient(to bottom right, #f1d313  0%, #FBB034 100%);
 //  	color: #fff;
	// border:none
 //  }
 //  @include tweak(delete-btn){
	//   background:linear-gradient(to bottom right, #ff0000 0%, #990000 100%);
	//   color:#fff;
	//   border:none
 //  }
 //  @include tweak(check-btn){
	//   background:linear-gradient(to bottom right,#00f2fe 0%, #1e63c3 100%);
	//   color:#fff;
	//   border:none
 //  }
 //  @include tweak(main-color){
	//   background:linear-gradient(to bottom right, #9853af,#623AA2);
	//   color:#fff;
	//   border:none
 //  }
 .tox-silver-sink{
   z-index: 9999 !important;
 }
 .tox-tinymce{
   min-height: 350px !important;
 }
.distpicker-address-wrapper select{
	font-size: 14px!important;
}
</style>
